import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Add: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={color}>
        <rect height="4" rx="2" width="24" y="10" />
        <rect
          height="4"
          rx="2"
          transform="matrix(0 -1 1 0 -14 34)"
          width="24"
          x="10"
          y="24"
        />
      </g>
    </svg>
  );
};

export default Add;
